/**
 * Klaviyo list subscribe + email popup wiring for Suggafoot's theme.
 * Requires window.SF_KLAVIYO (companyId, listId) from sf-klaviyo-config snippet.
 */
(function () {
  var config = window.SF_KLAVIYO;
  if (!config || !config.companyId) return;

  function subscribeEmail(email, source, listIdOverride) {
    var listId = listIdOverride || config.listId;
    if (!listId) {
      return Promise.reject(new Error('Klaviyo list ID is not configured in theme settings.'));
    }

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source || "Suggafoot website",
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId,
            },
          },
        },
      },
    };

    var url =
      'https://a.klaviyo.com/client/subscriptions/?company_id=' +
      encodeURIComponent(config.companyId);

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        revision: config.revision || '2025-04-15',
      },
      body: JSON.stringify(payload),
    }).then(function (response) {
      if (response.status === 202 || response.ok) return response;
      return response.text().then(function (text) {
        var message = 'Unable to subscribe. Please try again.';
        try {
          var parsed = JSON.parse(text);
          if (parsed.errors && parsed.errors[0] && parsed.errors[0].detail) {
            message = parsed.errors[0].detail;
          }
        } catch (e) {
          /* use default message */
        }
        throw new Error(message);
      });
    });
  }

  window.SF_KLAVIYO_SUBSCRIBE = subscribeEmail;

  function bindKlaviyoForms() {
    document.querySelectorAll('[data-sf-klaviyo-form]').forEach(function (form) {
      if (form.dataset.sfKlaviyoBound === 'true') return;
      form.dataset.sfKlaviyoBound = 'true';

      var source = form.getAttribute('data-sf-klaviyo-source') || "Suggafoot's website";
      var listIdOverride = form.getAttribute('data-sf-klaviyo-list-id') || '';
      var emailInput = form.querySelector('[data-sf-klaviyo-email]');
      var submitBtn = form.querySelector('[type="submit"]');
      var successEl = form.querySelector('[data-sf-klaviyo-success]');
      var errorEl = form.querySelector('[data-sf-klaviyo-error]');

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!emailInput) return;

        var email = (emailInput.value || '').trim();
        if (!email) {
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent = 'Please enter your email address.';
          }
          return;
        }

        if (errorEl) errorEl.hidden = true;
        if (successEl) successEl.hidden = true;
        if (submitBtn) submitBtn.disabled = true;

        subscribeEmail(email, source, listIdOverride || null)
          .then(function () {
            if (successEl) successEl.hidden = false;
            var fieldsWrap =
              form.querySelector('[data-sf-klaviyo-fields]') ||
              form.querySelector('.sf-email-popup-fields, .sf-footer-subscribe-fields');
            if (fieldsWrap) fieldsWrap.hidden = true;
            if (window._learnq) {
              window._learnq.push(['identify', { $email: email }]);
              window._learnq.push(['track', 'Subscribed to Email List', { source: source }]);
            }
            document.dispatchEvent(
              new CustomEvent('sf:klaviyo:subscribed', { detail: { email: email, source: source } })
            );
          })
          .catch(function (err) {
            if (errorEl) {
              errorEl.hidden = false;
              errorEl.textContent = err.message || 'Something went wrong. Please try again.';
            }
          })
          .finally(function () {
            if (submitBtn) submitBtn.disabled = false;
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindKlaviyoForms);
  } else {
    bindKlaviyoForms();
  }

  document.addEventListener('shopify:section:load', bindKlaviyoForms);
})();
